import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import Workspace from './Workspace';
import { config } from '../ts/config';
import * as reactGlobalClick from '../../../_common/platform/ts/reactGlobalClick';
import * as appTheme from '../../../_common/platform/ts/appTheme';
import ErrorBoundary from '../../../_common/platform/tsx/ErrorBoundary';
import ComponentRenderer from './ComponentRenderer';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';

import { IAppState, ITab } from '../ts/stores/AppStore';
import { IWidgetEditState } from '../ts/stores/WidgetEditStore';

import { Notifications } from './notifications/Notifications';
import { DirPermissions } from './DirPermissions';
import { SignInPopup } from './SignInPopup';
import { ErrorForm } from './ErrorForm';
import { TemplateEdit } from './TemplateEdit';
import { Dialogs } from './Dialogs';
import { ThemeRenderer } from './ThemeRenderer';
//import { UserSettingsView } from './UserSettingsView';
import { WidgetEdit } from './WidgetEdit';
import { WorkspaceEdit } from './WorkspaceEdit';

const APP_SETTINGS_DEFAULT_THEME_FIELD = 'theme/default';

export interface IProperties {
    glob: IGlob;
}

interface IState extends IWidgetEditState {
    appState: IAppState;
}

export default class Module extends React.Component<IProperties, IState> {
    constructor(props) {
        super(props);

        this.state = this.getState();
    }

    getState(): IState {
        return {
            appState: this.props.glob.AppStore.getState()
        };
    }

    componentDidMount() {
        this.props.glob.AppStore.addChangeListener(this.handleOnStoreChange);
        this.props.glob.SettingsStore.addChangeListener(this.handleOnStoreChange);

        this.setTheme();

        config.LAYOUT_TYPE = this.getLayoutType();
    }

    private getLayoutType() {
        const width = screen.width;
        const height = screen.height;

        // narrow layout -- for mobile devices
        if ((width > 0 && width < 750) || (height > 0 && height < 500)) {
            return 'narrow';
        } else {
            return 'normal';
        }
    }

    componentWillUnmount() {
        this.props.glob.AppStore.removeChangeListener(this.handleOnStoreChange);
        this.props.glob.SettingsStore.removeChangeListener(this.handleOnStoreChange);
    }

    componentDidUpdate(prevProps, prevState) {
        this.setTheme();
    }

    handleOnStoreChange = () => {
        this.setState(this.getState());
    };

    setTheme() {
        const container = $('.pdc-bootstrap.pdc-platform');

        container.removeClass().addClass('pdc-platform pdc-bootstrap');
    }

    // processSignOut(e) {
    //     this.props.glob.AppActions.signOut();

    //     e.stopPropagation();
    //     e.preventDefault();
    // }

    // showDirs(e) {
    //     this.props.glob.mainRouter.navigate('/workspace-explorer', { trigger: true });
    // }

    // showTemplates(e) {
    //     this.props.glob.mainRouter.navigate('/templates-explorer', { trigger: true });
    // }

    // getMainView() {
    //     var content = [];

    //     content.push(
    //         <nav
    //             key={"main-view-navbar"}
    //             className="navbar navbar-default main-navigation" role="navigation"
    //         >
    //             <div className="container-fluid">
    //                 <div className="navbar-header">
    //                     <a className="navbar-brand" href="/">PDC dashboard</a>
    //                 </div>

    //                 <button
    //                     type="button"
    //                     className="btn btn-default navbar-btn"
    //                     onClick={ this.showDirs }
    //                 >
    //                     Workspace explorer
    //                 </button>

    //                 <button
    //                     type="button"
    //                     className="btn btn-default navbar-btn"
    //                     onClick={ this.showTemplates }
    //                 >
    //                     Templates explorer
    //                 </button>

    //                 <button
    //                     type="button"
    //                     className="btn btn-default navbar-btn navbar-right"
    //                     onClick={ this.processSignOut }
    //                 >
    //                     Sign out
    //                 </button>

    //                 <p className="navbar-text navbar-right">
    //                     Logged in as{ ' ' + this.state.authData.displayName }
    //                 </p>
    //             </div>
    //         </nav>
    //     );

    //     if (this.state.showDirsWorkspaces) {
    //         content.push(
    //             <DirsWorkspaces
    //                 id="main-view-workspaces-dirs"
    //                 key={"main-view-workspaces-dirs"}

    //                 glob={ this.props.glob }
    //             />
    //         );

    //     } else if (this.state.showDirsTemplates) {
    //         content.push(
    //             <DirsTemplates
    //                 key={"dirs-templates"}

    //                 glob={ this.props.glob }
    //             />
    //         );
    //     }

    //     return content;
    // }

    getTabsInfo() {
        let tabs: ITab[];
        let tabDisplay: number;

        if (this.state.appState.maximizedTab != null) {
            tabs = [this.state.appState.maximizedTab];
            tabDisplay = 0;
        } else {
            tabs = this.state.appState.tabs;
            tabDisplay = this.state.appState.tabDisplay;
        }

        return { tabs, tabDisplay };
    }

    globalClick = (e) => {
        reactGlobalClick.trigger(e);
    };

    getTheme(displayTab: ITab, defaultThemeField) {
        const workspaceState = this.props.glob.WorkspaceStore.getInstanceState(
            displayTab.workspaceID || displayTab.cid,
            displayTab.workspaceID == null
        );
        const workspaceTheme = (workspaceState.data && workspaceState.data.theme) || {};

        return appTheme.extend(
            {},
            defaultThemeField,
            defaultThemeField?._custom,
            workspaceTheme,
            workspaceTheme._custom
        );
    }

    render() {
        const { glob } = this.props;
        const { appState } = this.state;
        const { tabs, tabDisplay } = this.getTabsInfo();
        const displayTab = tabs[tabDisplay];
        const defaultThemeField = glob.SettingsStore.getAppSetting(APP_SETTINGS_DEFAULT_THEME_FIELD);
        const theme = this.getTheme(displayTab, defaultThemeField);
        const content = [];
        const absoluteComponents = [];

        if (appState.showErrorForm != null) {
            content.push(<ErrorForm key="error-form" glob={glob} error={appState.showErrorForm} />);
        } else {
            if (appState.authorized !== true && appState.loading === false && appState.showSignInForm !== false) {
                content.push(<SignInPopup key="sign-in-view" glob={glob} />);
            }
        }

        if (appState.initialized && appState.authorized) {
            if (appState.showComponent) {
                absoluteComponents.push(
                    <ComponentRenderer
                        key="component-renderer"
                        moduleName={appState.componentModuleName}
                        componentProps={appState.componentProps}
                        glob={glob}
                    />
                );
            } else {
                if (appState.showWorkspaceEditView) {
                    absoluteComponents.push(<WorkspaceEdit key="workspace-edit" glob={glob} />);
                }

                // Workspace View.
                // 'originTab' is the tab a maximized widget references to get Global State and so on.
                tabs.forEach((tab, index) => {
                    if (tab.visible || index === tabDisplay) {
                        absoluteComponents.push(
                            <Workspace
                                key={tab.workspaceID + '-' + tab.id}
                                tab={tab.originTab ?? tab.id}
                                actualTab={tab.originTab != null ? tab.id : undefined}
                                mainTab={null}
                                id={tab.workspaceID}
                                cid={tab.cid}
                                hidden={tabDisplay !== index || !appState.pageIsVisible}
                                isChildWorkspace={false}
                                tabs={tabs}
                                tabDisplay={tabDisplay}
                                contentChanged={tab.contentChanged != null}
                                widget={tab.widget}
                                widgetTheme={tab.widgetTheme}
                                widgetState={tab.widgetState}
                                distractFree={
                                    tab.distractFree === true || config.PRINT_MODE || config.SINGLE_WORKSPACE != null
                                }
                                theme={appTheme.extend({}, defaultThemeField, defaultThemeField?._custom)}
                                query={tab.query}
                                glob={glob}
                            />
                        );
                    }
                });

                if (appState.showTemplateEdit) {
                    content.push(<TemplateEdit key="template-edit" glob={glob} />);
                }
            }
        } else if (appState.loading) {
            content.push(
                <div key="progress-bar" className="global-progress">
                    <ProgressBar />
                </div>
            );
        }

        // if (appState.showUserSettingsView) {
        //     absoluteComponents.push(<UserSettingsView key="user-settings" glob={glob} />);
        // }

        if (appState.showDirPermissions) {
            absoluteComponents.push(<DirPermissions key="dir-permissions" theme={theme} glob={glob} />);
        }

        let absoluteContainer: React.JSX.Element;

        if (absoluteComponents.length > 0) {
            absoluteContainer = <div className="absolute-container">{absoluteComponents}</div>;
        }

        if (appState.showWidgetEdit) {
            content.push(<WidgetEdit key="widget-edit" theme={theme} glob={glob} />);
        }

        return (
            <ErrorBoundary>
                <div className={'main-view-container'} onClick={this.globalClick}>
                    <ThemeRenderer theme={theme} levels={['workspace', 'application']} />
                    <Notifications glob={glob} />
                    <Dialogs glob={glob} />

                    {content}
                    {absoluteContainer}
                </div>
            </ErrorBoundary>
        );
    }
}
